import React, { useEffect, useState } from "react";
import PTFormInput from "./PTFormInput";
import getReferentielData, { getReferentielDataFromServer } from "../general/AxiosReferencielInterceptor";

export const PTDynamicFormField = ({
  name,
  reference,
  apiOptions,
  data = [],
  dataPath = "results",
  labelParamRenderer = (item) => item.description,
  valueParamRenderer = (item) => item.code,
  transformData = (data) => data,
  itemJson= ["id"],
  isHidden,
  xs = 12,
  md = 4,
  lg = 3,
  gridOptions,
  label,
  required,
  hiddenLabel,
  tooltip,
  multiline = false,
  placeHolder,
  height = 40,
  rows = 1,
  disabled = false,
  children,
  ...props
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let _data;
        if (reference && reference != "") {
            _data = await getReferentielData(reference);
        } 
        else if (apiOptions && Object.keys(apiOptions).length > 0) {
            if (!apiOptions?.preRequis || apiOptions?.preRequis?.()) {
              _data = await getReferentielDataFromServer(
                apiOptions?.urlStatic || false,
                apiOptions.api,
                apiOptions.body,
                apiOptions.method
              );
            } else {
              _data = {};
            }
          }
        else {
          _data = {results: data};
        }
        const dataFetched = dataPath == "none" ? data : _data?.[dataPath] || [];
        const refactoData = dataFetched?.map((item) => {
          return {
            ...item,
            label: labelParamRenderer(item),
            value: valueParamRenderer(item),
            ...itemJson?.reduce((acc, key) => {
              if (item[key] !== undefined) {
                acc[key] = item[key];
              }
              return acc;
            }, {}),
          }
        }) || [];
        setOptions(transformData(refactoData));
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const componentWithProps = React.Children.map(children, (child) => {
    return React.cloneElement(child, {
      options: options,
    });
  });

  return (
    <PTFormInput
      isHidden={isHidden}
      label={label}
      required={required}
      tooltip={tooltip}
      hiddenLabel={hiddenLabel}
      name={name}
      md={md}
      xs={xs}
      lg={lg}
      {...gridOptions}
    >
      {componentWithProps}
    </PTFormInput>
  );
};

export default PTDynamicFormField;
